// Cloudflare request geo (raw_entries.*_at_create_time) → map shapes, by name
// only. country is ISO alpha-2 and matches the world shapes' `iso` as is; for
// Portugal, region is the district / autonomous region in English ("Lisbon",
// "Azores", "Évora"), which is the district shapes' `name_en` — `name` (the
// Portuguese form) and ALIASES cover the spellings Cloudflare could also use.

export const normalizePlaceName = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()

// Extra spellings → district ISO 3166-2 code.
const ALIASES: Record<string, string> = {
  'acores': 'PT-20',
  'regiao autonoma dos acores': 'PT-20',
  'autonomous region of the azores': 'PT-20',
  'regiao autonoma da madeira': 'PT-30',
  'autonomous region of madeira': 'PT-30',
  'madeira islands': 'PT-30',
}

export type DistrictProps = { iso: string; name: string; name_en: string; type: string }

/** name → district iso, built from the shapes' own names plus ALIASES. */
export function buildDistrictIndex(districts: DistrictProps[]): (region: string | null) => string | null {
  const index = new Map<string, string>(Object.entries(ALIASES))
  for (const d of districts) {
    index.set(normalizePlaceName(d.name), d.iso)
    index.set(normalizePlaceName(d.name_en), d.iso)
  }
  return (region) => (region ? index.get(normalizePlaceName(region)) ?? null : null)
}
